import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyAhA3JoADYUTJk46YDUc5oKO7_dRFHGgg0',
  authDomain: 'liquid-finance-487219.firebaseapp.com',
  projectId: 'liquid-finance-487219',
  storageBucket: 'liquid-finance-487219.firebasestorage.app',
  messagingSenderId: '120401664027',
  appId: '1:120401664027:web:eaf6183dd8b37f280600be',
}

const app = initializeApp(firebaseConfig)
export const auth = getAuth(app)
export const db = getFirestore(app)
